import { GoalsNavigation } from "src/GoalsNavigation";
import { RegistrationNavigation } from "src/RegistrationNavigation";
import { TestModuleNavigation } from "src/TestModuleNavigation";
import { configurationNavigation } from "src/configurationNavigation";
import { financeNavigation } from "src/financeNavigation";
import { marketingNavigation } from "src/marketingNavigation";
import { UserModuleActionTypes } from "src/models/userAccess/UserAccess.model";
import {
  ModulesTypes,
  moduleActionTypes,
} from "src/redux/slices/access/userAcessSlice";
import store from "src/redux/store";
import { viewBatchTabs } from "src/screens/Batch/View/ViewBatchLayout";
import { inquiriesEditTabs } from "src/screens/Inquiry/Edit/Layout/InquiryLayout";

export const isCheckForNavigationPath = (moduleName: string) => {
  const { userAccessItems } = store.getState().userAccess;
  const { userType } = store.getState().auth;
  const isExist = userAccessItems.modules?.find(
    (module: ModulesTypes) =>
      moduleName === module.moduleName || module.childGroup.includes(moduleName)
  );

  if (isExist) {
    return true;
  }
  if (userType === "ADMIN") return true;

  return false;
};

export const isCheckModuleForNavigationPath = (
  moduleName: string,
  path: string
): string => {
  const { userAccessItems } = store.getState().userAccess;
  let pathName = "";
  switch (moduleName) {
    case "CONFIGURATION":
      for (const navigation of configurationNavigation) {
        const isExist = userAccessItems.modules.find(
          (module: ModulesTypes) => module.moduleName === navigation.moduleName
        );
        if (isExist) {
          pathName = `/configuration/${navigation.path}`;
          break; // Break after the first matching module
        }
      }
      return pathName || path; // Provide a default value or handle the case when no matching module is found
      case "MARKETING":
      for (const navigation of marketingNavigation) {
        const isExist = userAccessItems.modules.find(
          (module: ModulesTypes) => module.moduleName === navigation.moduleName
        );
        if (isExist) {
          pathName = `/marketing/${navigation.path}`;
          break; // Break after the first matching module
        }
      }
      return pathName || path;
      case "FINANCE":
        for (const navigation of financeNavigation) {
          const isExist = userAccessItems.modules.find(
            (module: ModulesTypes) => module.moduleName === navigation.moduleName
          );
          if (isExist) {
            pathName = `/finance/${navigation.path}`;
            break; // Break after the first matching module
          }
        }
        return pathName || path;
        case "GOAL_CONFIGURATION":
        for (const navigation of GoalsNavigation) {
          const isExist = userAccessItems.modules.find(
            (module: ModulesTypes) => module.moduleName === navigation.moduleName
          );
          if (isExist) {
            pathName = `/goals/${navigation.path}`;
            break; // Break after the first matching module
          }
        }
        return pathName || path;
          case "REGISTRATION":
        for (const navigation of RegistrationNavigation) {
          const isExist = userAccessItems.modules.find(
            (module: ModulesTypes) => module.moduleName === navigation.moduleName
          );
          if (isExist) {
            pathName = `/registration/${navigation.path}`;
            break; // Break after the first matching module
          }
        }
        return pathName || path;
        case "TEST_MODULE":
          for (const navigation of TestModuleNavigation) {
            const isExist = userAccessItems.modules.find(
              (module: ModulesTypes) => module.moduleName === navigation.moduleName
            );
            if (isExist) {
              pathName = `/test-module/${navigation.path}`;
              break; // Break after the first matching module
            }
          }
          return pathName || path;

    default:
      return path;
  }
};

export const isCheckModuleActionForNavigationPath = (
  moduleName: string,
  path: string,
  navigate: any
) => {
  const { userAccessItems } = store.getState().userAccess;

  switch (moduleName) {
    case "INQUIRIES":
      let pathName = "";
      for (const navigation of inquiriesEditTabs) {
        const isExist = userAccessItems.modules.find(
          (module: ModulesTypes) => module.moduleName === moduleName
        );
        const actionExist = isExist?.moduleAction?.find(
          (action: moduleActionTypes) =>
            action.actionName === navigation.actionName
        );
        if (actionExist) {
          pathName = `${path}/${navigation.path}`;
          break; // Break after the first matching module
        }
      }
      return pathName ? navigate(pathName) : ""; // Provide a default value or handle the case when no matching module is found
      case "BATCH":
        let pathName2 = "";
        for (const navigation of viewBatchTabs) {
          const isExist = userAccessItems.modules.find(
            (module: ModulesTypes) => module.moduleName === moduleName
          );
          const actionExist = isExist?.moduleAction?.find(
            (action: moduleActionTypes) =>
              action.actionName === navigation.actionName
          );
          if (actionExist) {
            pathName2 = `${path}/${navigation.path}`;
            break; // Break after the first matching module
          }
        }
        return pathName2 ? navigate(pathName2) : ""; // Provide a default value or handle the case when no matching module is foun
    default:
      return path;
  }
};
export const isCheckActionsPermission = ({
  moduleName,
  actionName,
}: {
  moduleName: string;
  actionName: string;
}) => {
  const { userType } = store.getState().auth;
  if (userType === "ADMIN") {
    return true;
  }
  const { userAccessItems } = store.getState().userAccess;
  const isExist = userAccessItems.modules
    .find((module: ModulesTypes) => module.moduleName === moduleName)
    ?.moduleAction?.find(
      (action: moduleActionTypes) => action.actionName === actionName
    );
  if (isExist) {
    return true;
  }
  return false;
};

export const isCheckColumnPermission = ({
  moduleName,
  actionName,
  columns,
  actionArray = [],
}: {
  moduleName: string;
  actionName: string;
  columns: any;
  actionArray?: string[];
}) => {
  const { userType } = store.getState().auth;
  const { userAccessItems: userAccessData } = store.getState().userAccess;
  let modules = userAccessData?.modules?.find(
    (modules: ModulesTypes) => modules.moduleName === moduleName
  );
  let moduleAction = modules?.moduleAction?.find((modulesActionkey: any) => {
    return modulesActionkey?.actionName === actionName;
  });
  let isEditDeleteViewAccess = modules?.moduleAction?.some((mod: any) => {
    if (actionArray.length) {
      return actionArray.includes(mod.actionName);
    } else {
      return (
        mod?.actionName === UserModuleActionTypes.VIEW ||
        mod?.actionName === UserModuleActionTypes.EDIT ||
        mod?.actionName === UserModuleActionTypes.DELETE 
      );
    }
  });
  let allowedFields = moduleAction?.fields?.map((ele: any) => {
    return ele?.fieldValue;
  });
  if (isEditDeleteViewAccess) {
    allowedFields?.push("action");
  }
  let allowedColumn = columns?.filter((col: any) => {
    return allowedFields?.includes(col?.field);
  });

  return userType === "ADMIN" ? columns : allowedColumn;
};
